import zod from 'zod'

export const cardDataFormSchema = zod.object({
  number: zod.preprocess(
    (value) => {
      if (typeof value === 'string') {
        value = value.replace(/\s/g, '')
      }
      return value
    },
    zod
      .string({ required_error: 'Campo obrigatório' })
      .min(1, 'Campo obrigatório')
      .regex(/^[0-9\s]+$/, 'Número inválido')
      .length(16, 'Número inválido'),
  ),
  payment_method: zod.enum(['credit_card', 'debit_card'], {
    errorMap: () => ({ message: 'Campo obrigatório' }),
  }),
  installments: zod.number().min(1).max(12),
  holder_name: zod.string().min(1, 'Campo obrigatório'),
  expiration: zod
    .string({ required_error: 'Campo obrigatório' })
    .min(5, 'Campo obrigatório')
    .superRefine((val, ctx) => {
      const [month, year] = val.split('/')

      const now = new Date()
      const currentYear = now.getFullYear() % 100
      const currentMonth = now.getMonth() + 1
      const cardYear = Number(year)
      const cardMonth = Number(month)

      const invalid =
        cardMonth > 12 ||
        cardYear < currentYear ||
        (cardYear === currentYear && cardMonth < currentMonth)

      if (invalid) {
        ctx.addIssue({
          code: zod.ZodIssueCode.invalid_date,
          message: 'Formato inválido',
        })
      }
    }),
  cvv: zod
    .string({ required_error: 'Campo obrigatório' })
    .min(3, 'Campo obrigatório')
    .max(4, 'Campo obrigatório')
    .trim()
    .regex(/^[0-9]+$/, 'Número inválido'),
  billing_address: zod.object({
    line_1: zod.string({ required_error: 'Obrigatório' }).min(3, 'Obrigarório'),
    line_2: zod.string({ required_error: 'Obrigatório' }).optional().nullable(),
    zip_code: zod
      .string()
      .min(9, 'Deve ter no mínimo 8 números')
      .transform((v) => v.replaceAll(/\D/g, '')),
    city: zod.string({ required_error: 'Obrigatório' }).min(3, 'Obrigarório'),
    state: zod
      .string({ required_error: 'Obrigatório' })
      .max(2, 'RJ, BA, SP')
      .toUpperCase(),
    country: zod.string().max(2).toUpperCase(),
  }),
})

export type CardDataFormValues = zod.infer<typeof cardDataFormSchema>
